import PropTypes from 'prop-types';
import styles from './FJMenu.module.less';
import classNames from 'classnames';
import FJLocalStore from '../../../store/FJLocalStore.js';

const FJMenu = props => {
    const { selectTab, onChangeTab, tabList, style, keyValue = 'name' } = props;

    return (
        <ul className={classNames(styles.container)} style={style}>
            {tabList.map((tab, index) => {
                return (
                    <li
                        className={classNames(styles.item, selectTab === index ? styles.active : null)}
                        key={tab.value}
                        onClick={() => {
                            onChangeTab(tab, index);
                        }}
                    >
                        {selectTab === index ? <tab.hoverIcon /> : <tab.icon />}
                        <div className={styles.text}>{FJLocalStore._(tab[keyValue])}</div>
                    </li>
                );
            })}
        </ul>
    );
};

FJMenu.propTypes = {
    selectTab: PropTypes.string,
    onChangeTab: PropTypes.func,
    tabList: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            icon: PropTypes.elementType.isRequired,
        }),
    ),
    style: PropTypes.object,
    keyValue: PropTypes.string,
};

export default FJMenu;
